<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_ix"></a>Naming Conventions</h2>
<p class="noindent">Place-names have generally been used as existed at the time of the campaign in 1794. Most survive to this day, however some clarification is required concerning the names of the principal towns and fortresses on Martinique.</p>
<p class="indent">Convention at the time was such that such places were named by the ruling power, and changed names as ownership changed. Thus, the town of Fort Royal (under the Bourbons) became ‘République-ville’ under the Republicans; by the same process Fort Louis became ‘Fort de la République’ and Fort Bourbon became ‘Fort de la Convention’, and later ‘Fort Edward’ after capture by the British.</p>
<p class="indent">In deference to what such places were actually called at the time of the campaign, and in homage to the considerable skill and tenacity of the defenders, I have opted to use the French Republican names for these places. However, wherever a pre- Revolutionary reference is required, or where memoirists have used the earlier Royalist form of the names, I have left them in the older style.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// naming.vue?10550f02